<template>
  <div>
    <w-camera-button 
      :disabled="disabled"
      @click="handleCameraEvent"
    />
  </div>
</template>

<script>
import fileUploadMixin from '@/mixins/file-upload-mixin';

/**
 * @component WorkUploadButtons
 * @description Upload button group for file and camera upload.
 * Integrates `fileUploadMixin` for full upload logic.
 *
 * @prop {String} targetFieldPath - Store path where the files are saved. (Required)
 * @prop {Object} [taskPayload] - Additional payload for the upload task.
 * @prop {String} [cameraButtonClass=''] - CSS class for the camera button.
 * @prop {Function} fileSubmitCallback - Callback after successful file upload. (Required)
 * @prop {Boolean} [disabled=false] - Disable the buttons.
 */
export default {
  name: 'WorkUploadButtons',
  props: {
    targetFieldPath: { type: String, required: true },
    taskPayload: { type: Object },
    cameraButtonClass: {type: String, default: ""}, 
    fileSubmitCallback: { type: Function, required: true },
    disabled: { type: Boolean, default: false },
  },
  mixins: [    
    fileUploadMixin({
      fileSubmitCallback: (self) => self.fileSubmitCallback,
      targetFieldPath: (self) => self.targetFieldPath,
      taskPayload: (self) => self.taskPayload,
    }),
  ],
};
</script>